import styled from 'styled-components';
import { media } from '@minecraft.themes';

export const StyledWrapper = styled.div`
  background-color: ${props => props.theme.colors.accent.ltGrey2};
  width: 100%;
  padding: 0 1rem;
`;

export const StyledStepsProgressBarInnerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 0 3rem;
  margin: 0 auto;
  max-width: 75rem;
  width: 100%;
  max-width: 40rem;
`;

export const StyledIndividualStepContainer = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
`;

export const StyledStepCount = styled.div<{ isActive: boolean }>`
  width: 2.25rem;
  height: 2.25rem;
  font-weight: 500;
  background-color: ${props =>
    props.isActive ? props.theme.colors.primary.primary : props.theme.colors.accent.ltGrey4};
  color: ${props => props.theme.colors.primary.white};
  border-radius: 0.25rem;
`;

export const StyledStepName = styled.div`
  font-size: 0.875rem;
  line-height: normal;
  margin-top: 0.5rem;
  position: absolute;
  top: 100%;

  ${media.md`
    font-size: 1rem;
  `}
`;

export const StyledDivider = styled.span<{ $isActive: boolean }>`
  flex-grow: 1;
  border-bottom: 2px solid
    ${props => (props.$isActive ? props.theme.colors.primary.primary : props.theme.colors.accent.ltGrey4)};
`;
